var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#182617"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1319_55338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 42,
    height: 42
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 42,
    height: 42,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1319_55338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.55 36.05L37.8875 23.7125L35.4375 21.2625L25.55 31.15L20.5625 26.1625L18.1125 28.6125L25.55 36.05ZM28 45.5C25.5792 45.5 23.3042 45.0403 21.175 44.121C19.0458 43.2028 17.1938 41.9563 15.6188 40.3813C14.0438 38.8063 12.7972 36.9542 11.879 34.825C10.9597 32.6958 10.5 30.4208 10.5 28C10.5 25.5792 10.9597 23.3042 11.879 21.175C12.7972 19.0458 14.0438 17.1938 15.6188 15.6188C17.1938 14.0438 19.0458 12.7966 21.175 11.8772C23.3042 10.9591 25.5792 10.5 28 10.5C30.4208 10.5 32.6958 10.9591 34.825 11.8772C36.9542 12.7966 38.8063 14.0438 40.3813 15.6188C41.9563 17.1938 43.2028 19.0458 44.121 21.175C45.0403 23.3042 45.5 25.5792 45.5 28C45.5 30.4208 45.0403 32.6958 44.121 34.825C43.2028 36.9542 41.9563 38.8063 40.3813 40.3813C38.8063 41.9563 36.9542 43.2028 34.825 44.121C32.6958 45.0403 30.4208 45.5 28 45.5Z",
    fill: "#3ECD00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastSuccess);
export default __webpack_public_path__ + "static/media/toast-success.feb6b7904ac37d6aafba8a9ba1475a46.svg";
export { ForwardRef as ReactComponent };